/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateEquipmenttypeDto } from '../models/work-create-equipmenttype-dto';
import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';
import { WorkEquipmenttype } from '../models/work-equipmenttype';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkUpdateEquipmenttypeDto } from '../models/work-update-equipmenttype-dto';

@Injectable({ providedIn: 'root' })
export class WorkEquipmenttypesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `equipmenttypesV2ControllerGetAllDropdownOptions()` */
  static readonly EquipmenttypesV2ControllerGetAllDropdownOptionsPath = '/v2/equipmenttypes/dropdown-options';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmenttypesV2ControllerGetAllDropdownOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmenttypesV2ControllerGetAllDropdownOptions$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmenttypesV2Service.EquipmenttypesV2ControllerGetAllDropdownOptionsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmenttypesV2ControllerGetAllDropdownOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmenttypesV2ControllerGetAllDropdownOptions(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.equipmenttypesV2ControllerGetAllDropdownOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `equipmenttypesV2ControllerFindAllPaginated()` */
  static readonly EquipmenttypesV2ControllerFindAllPaginatedPath = '/v2/equipmenttypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmenttypesV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmenttypesV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li>
     * <li>description</li>
     * <li>active</li>
     * <li>equipmentCount</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC' | 'description:ASC' | 'description:DESC' | 'active:ASC' | 'active:DESC' | 'equipmentCount:ASC' | 'equipmentCount:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,description
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>description</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkEquipmenttype>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmenttypesV2Service.EquipmenttypesV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkEquipmenttype>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        };
        };
        }>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmenttypesV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmenttypesV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li>
     * <li>description</li>
     * <li>active</li>
     * <li>equipmentCount</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC' | 'description:ASC' | 'description:DESC' | 'active:ASC' | 'active:DESC' | 'equipmentCount:ASC' | 'equipmentCount:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,description
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>description</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkEquipmenttype>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}> {
    return this.equipmenttypesV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkEquipmenttype>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkEquipmenttype>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
} => r.body)
    );
  }

  /** Path part for operation `equipmenttypesV2ControllerCreate()` */
  static readonly EquipmenttypesV2ControllerCreatePath = '/v2/equipmenttypes';

  /**
   * Required permissions: equipments:admin, equipmenttypes:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmenttypesV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmenttypesV2ControllerCreate$Response(
    params: {
      body: WorkCreateEquipmenttypeDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEquipmenttype>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmenttypesV2Service.EquipmenttypesV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEquipmenttype>;
      })
    );
  }

  /**
   * Required permissions: equipments:admin, equipmenttypes:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmenttypesV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmenttypesV2ControllerCreate(
    params: {
      body: WorkCreateEquipmenttypeDto
    },
    context?: HttpContext
  ): Observable<WorkEquipmenttype> {
    return this.equipmenttypesV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEquipmenttype>): WorkEquipmenttype => r.body)
    );
  }

  /** Path part for operation `equipmenttypesV2ControllerFindOneById()` */
  static readonly EquipmenttypesV2ControllerFindOneByIdPath = '/v2/equipmenttypes/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmenttypesV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmenttypesV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEquipmenttype>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmenttypesV2Service.EquipmenttypesV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEquipmenttype>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmenttypesV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmenttypesV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkEquipmenttype> {
    return this.equipmenttypesV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEquipmenttype>): WorkEquipmenttype => r.body)
    );
  }

  /** Path part for operation `equipmenttypesV2ControllerDelete()` */
  static readonly EquipmenttypesV2ControllerDeletePath = '/v2/equipmenttypes/{id}';

  /**
   * Required permissions: equipments:admin, equipmenttypes:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmenttypesV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmenttypesV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmenttypesV2Service.EquipmenttypesV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: equipments:admin, equipmenttypes:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmenttypesV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmenttypesV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.equipmenttypesV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `equipmenttypesV2ControllerUpdate()` */
  static readonly EquipmenttypesV2ControllerUpdatePath = '/v2/equipmenttypes/{id}';

  /**
   * Required permissions: equipments:admin, equipmenttypes:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmenttypesV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmenttypesV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateEquipmenttypeDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEquipmenttype>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmenttypesV2Service.EquipmenttypesV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEquipmenttype>;
      })
    );
  }

  /**
   * Required permissions: equipments:admin, equipmenttypes:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmenttypesV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmenttypesV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateEquipmenttypeDto
    },
    context?: HttpContext
  ): Observable<WorkEquipmenttype> {
    return this.equipmenttypesV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEquipmenttype>): WorkEquipmenttype => r.body)
    );
  }

}
